import { render, staticRenderFns } from "./RegentLighting.vue?vue&type=template&id=087471e8&scoped=true&"
import script from "./RegentLighting.vue?vue&type=script&lang=ts&"
export * from "./RegentLighting.vue?vue&type=script&lang=ts&"
import style0 from "./RegentLighting.vue?vue&type=style&index=0&id=087471e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087471e8",
  null
  
)

export default component.exports